import React, { useState, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import router from './router'
import { initIAM, getIAMConfig, performLogin } from './utils/iam'
import { message } from '@haier/bwd'

const App: React.FC = () => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const init = async () => {
      try {
        const iamConfig = getIAMConfig()
        initIAM(iamConfig)
        const loginResult = await performLogin()
        if (!loginResult.success) {
          message.error(loginResult.errorMessage || '登录失败')
        }
      } catch (e) {
        message.error('登录异常，请重试')
        console.error('IAM login error:', e)
      } finally {
        setReady(true)
      }
    }
    init()
  }, [])

  return ready ? <RouterProvider router={router} /> : null
}

export default App
